import { render, staticRenderFns } from "./OrderDetail.vue?vue&type=template&id=52f4b9cc&scoped=true&"
import script from "./OrderDetail.vue?vue&type=script&lang=js&"
export * from "./OrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./OrderDetail.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./OrderDetail.vue?vue&type=style&index=1&id=52f4b9cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f4b9cc",
  null
  
)

export default component.exports